import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./Box.module.scss";
export const Box = ({ title, children, accent, className }) => {
    return (_jsxs("div", { className: classNames(styles.box, { [styles.boxAccent]: accent }, className), children: [_jsx("p", { className: styles.boxTitle, children: title }), children] }));
};
//# sourceMappingURL=Box.js.map